import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const useEditEventMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ eventId, formData }) => {
      if (!eventId) {
        throw new Error('Event id is required to update');
      }

      const result = await api.editEvent(eventId, formData);
      if (!result.success) {
        throw new Error(result.message || 'Failed to update event');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (variables?.eventId) {
        await queryClient.invalidateQueries({ queryKey: queryKeys.detail(variables.eventId) });
      }
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
